import React from 'react';

const PaneButton = ({
  btnText,
  paneDataId,
  setActivePaneId,
  activePaneId,
}) => {
  const className = activePaneId === paneDataId ? 'paneButton paneButton--active' : 'paneButton';

  const handleOnClick = (paneDataId) => {
    setActivePaneId(paneDataId);
  };

  return (
    <button
      className={className}
      onClick={() => handleOnClick(paneDataId)}
      data-testid={`pane-button:${paneDataId}`}
    >
      { btnText }
    </button>
  );
};

export default PaneButton;
